window.Products.Book = {};
window.Products.Book.Book = function() {};
window.Products.Book.Book.inherits(window.Products.Product);
window.Products.Book.Book.dpi = 300;

window.Products.Book.Book.prototype.getSceneScale  = function(_from, _to){
	return 1;
};